import URL from './url'
import http from '@/utils/httpUtils'

/* 第三方ISV接口授权接口文档 */
export default {
  // 获取微信分享短链
  getShortLink(params) {
    return new Promise((resolve, reject) => {
      http
        .post(URL.API_WECHAT_SHORT_LINK, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 获取班级下所有家长短码
  getGuardianCode(params) {
    return new Promise((resolve, reject) => {
      http
        .get(URL.API_WECHAT_GET_GUARDIAN_CODE, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 获取家长下所有学生及对应关系
  getStudentRelation(params) {
    return new Promise((resolve, reject) => {
      http
        .get(URL.API_WECHAT_GET_STUDENTS, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 家长绑定
  gurdianBind(params) {
    return new Promise((resolve, reject) => {
      http
        .post(URL.API_WECHAT_BIND, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 家长解绑
  gurdianUnBind(params) {
    return new Promise((resolve, reject) => {
      http
        .post(URL.API_WECHAT_UNBIND, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 获取用户信息
  getWxUserInfo(params) {
    return new Promise((resolve, reject) => {
      http
        .post(URL.API_WECHAT_GET_USERINFO, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 判断机构是否开通微信家长端
  judgeRefister(params) {
    return new Promise((resolve, reject) => {
      http
        .get(URL.API_WECHAT_JUDGEREGISTER, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  }
}
